<script>
export default {
    props: {
        field: {
            type: Object,
            required: true
        },
        model: {
            type: Object,
            required: true
        }
    },
    computed: {
        colSpanClass() {
            return `sm:col-span-${this.field.colSpan}`;
        }
    },
    methods: {
        removeErrors(model, field) {
            if (model.errors && model.errors[field]) {
                model.errors[field] = null;
            }
        }
    }
};
</script>

<template>
    <div :class="colSpanClass">
        <label
            :for="field.id"
            class="block text-sm font-medium leading-5 text-gray-700"
            >{{ field.label }}</label
        >
        <div class="mt-1">
            <input
                v-if="field.type === 'text'"
                :id="field.id"
                v-model="model[field.id]"
                type="text"
                class="w-full bg-leonard-white placeholder:text-leonard-black-disabled text-leonard-black rounded lg:rounded-md p-4 border border-leonard-grey focus:outline-none focus:border-leonard-black-hover"
                :class="
                    model.errors && model.errors[field.id] ? 'not-valid' : ''
                "
                @input="removeErrors(model, field.id)"
                :minLength="field.minLength || null"
                :maxLength="field.maxLength || null"
            />
            <select
                v-if="field.type === 'select'"
                :id="field.id"
                v-model="model[field.id]"
                class="custom-select w-full py-4 px-4 pr-8 rounded lg:rounded-md leading-tight focus:outline-none border border-leonard-grey focus:border-leonard-black-hover"
                :class="
                    model.errors && model.errors[field.id] ? 'not-valid' : ''
                "
                @input="removeErrors(model, field.id)"
            >
                <option
                    v-for="option in field.options"
                    :key="option"
                    :value="option"
                    >{{ option }}</option
                >
            </select>
        </div>
        <div class="error" v-if="model.errors && model.errors[field.id]">
            {{ model.errors[field.id] }}
        </div>
    </div>
</template>

<style scoped lang="scss">
.error {
    font-size: 0.75em;
    color: #e64847;
}
.form-input-wrapper:focus-within {
    outline: none;
    box-shadow: 0 0 0 3px rgba(164, 202, 254, 0.45);
    border-color: #a4cafe;
}
.form-input-wrapper input:focus {
    outline: none;
}
.not-valid {
    border-color: #e64847;
}
</style>
